module.exports = {
      id: "proofread-usage",
      viewBox: "0 0 21.271 15.261",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#proofread",
      toString: function () {
        return this.url;
      }
    }